import Product from './Product';
import categories from './categories'

/**
 * 
 */
class SheetMusic extends Product {
   constructor(ipNumber, isbn, title, subtitle, description, author, subject, priceCad, priceUsd, number, image) {
      super(ipNumber, isbn, title, categories.music, priceCad, priceUsd, 'sheet music');
      this.subtitle = subtitle;
      this.description = description;
      this.author = author;
      this.subject = subject;
      this.number = number;
      this.image = image
   }

   
}

export default SheetMusic;